import React,{Component} from 'react';
import axios from 'axios';
import TabelaHotarari from './components/TabelaHotarari';
import './App.css';
import ReactSelector from './components/ReactSelector';




class App extends Component {

  constructor(){
    super();
    this.state={
      hotarariElo:[],
      hotarariElofiltrate:[],
      aniElo:[{value:"Toate Hotararile",label:"Toate Hotararile"}],
      cautareNume:'Cautare Nume Hotarare',
      cautareTitlu:'Cautare Titlu Hotarare',
      selectedAn:"Alegeti Anul"
    }
  }

  
  
  componentDidMount(){
    //const urlInitial="http://elo.primariabr.ro:9091/toatehotararile/231202";
    const urlInitial="https://srvhotarari.primariabr.ro/toatehotararile/231202";
    this.incarcHotarari(urlInitial,this.state.aniElo[0].value).then(()=>this.incarcAni(this.state.hotarariElo));
  }

  incarcHotarari=(urlHotarariElo)=> {
    return axios.get(urlHotarariElo,{headers: {
      'Access-Control-Allow-Origin': '*',
    }})
    .then(res=>{
      return res.data.sort(this.sortare);
    }).then(res=>{
      const hotarari=res;
      // console.log(hotarari);
      this.setState({hotarariElo:hotarari},this.incarcAni(this.state.hotarariElo),this.setState({hotarariElofiltrate:hotarari}));
    });
  }

  filtrezHotarari=(anHotarare)=>{
    // console.log("An",anHotarare);
    let hotararifiltrate=this.state.hotarariElo;
    if (!isNaN(anHotarare)){
      hotararifiltrate=hotararifiltrate.filter((hotarare)=>
      {
        return(hotarare.anul===anHotarare);
      });
    };
    this.setState({hotarariElofiltrate:hotararifiltrate,selectedAn:anHotarare});
  };

  // sortarevechi=(a, b)=> { 
  //   let digita=a.nume.match(/(\d+)/);
  //   let digitb=b.nume.match(/(\d+)/);
  //   return  parseInt(digita) === parseInt(digitb)
  //       ? parseInt(b.numar) - parseInt(a.numar)
  //       : parseInt(digitb) - parseInt(digita);
  // }


  sortare=(a, b)=> {
    if(b.anul===a.anul){
      return(parseInt(b.numar)-parseInt(a.numar));
    }else{
      return parseInt(b.anul)-parseInt(a.anul);
    }
  }
  
  incarcAni=(hotarariElo)=>{
    let unique = [...new Set(hotarariElo.map(a=>a.anul))]; 
    let toti=this.state.aniElo;
    let ani=unique.map(un=>({value:un,label:un}));
    //verific daca are si valori non numerice
    let anis=ani.sort((a,b)=>parseInt(b.value)-parseInt(a.value));
    // console.log(anis);
    this.setState({aniElo:toti.concat(anis)});
  }


  render() {
    return (
      <div className="App">
        <p>Hotarari CLM Braila</p>  
        <div className="selector">
          <ReactSelector aniElo={this.state.aniElo} filtrezhotarari={this.filtrezHotarari}/>
          <TabelaHotarari 
        hotarariElo={this.state.hotarariElofiltrate}
        cautareNume={this.state.cautareNume}
        cautareTitlu={this.state.cautareTitlu}
        aniElo={this.state.aniElo}
        selectedAn={this.state.selectedAn}
        />
        </div> 

      </div>
    );
  }

}

export default App; 
